module.exports = __webpack_public_path__ + "img/whats-new-2_en.50b25c6.jpg";